import { AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions} from '@aims/common-components';
import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { TransferHttpService, CacheItem, TenantConfig } from '../../../services/transfer-http/transfer-http.service';
import { Router } from '@angular/router';
import { PermissionsService } from '../../../services/permissions/permissions.service';
import { HrPscType } from 'src/models';



@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.component.html',
  providers: []
})

export class DashboardComponent {

 header: AimsCommonTableHeader[] = [
    { key: 'fullName', label: 'Employee', width: 200, type: 'string'},
    { key: 'pscTypeId', label: 'Type', type: AimsCommonTableHeaderType.DYNAMIC },
    { key: 'effectiveOn', label: 'Effective', type: 'date', format: 'shortDate'},
    { key: 'createdBy', label: 'Created By', width: 200, type: 'string' },
    { key: 'createdOn', label: 'Created On', type: 'date', format: 'shortDate' },
    { key: 'hrAuditedBy', label: 'Audited By', width: 200, type: 'string' },
    { key: 'hrAuditedOn', label: 'Audited On', type: 'date', format: 'shortDate' },
  ]
  tablePermissions: AimsCommonTablePermissions = {
    filter:false, create: false, update: false, delete: false, clear:false
  }

  ssTableLabel = "Self Service PSCs In Progress";
  dmTableLabel = "DM Self Service PSCs In Progress";
 
  constructor(private transferHttp: TransferHttpService,
    private router: Router,
    public permissions: PermissionsService) {
      
  }

  tenantUsesPsc: boolean = this.transferHttp.tenantConfig.hr.tenantUsesPsc;

  //***************************
  // HR Dashboard Variables
  //***************************
  ssPscTypeValues: Observable<HrPscType> = this.transferHttp.getHot(`hr/GetSelfServicePscTypes`);
  dmPscTypeValues: Observable<HrPscType> = this.transferHttp.getHot(`hr/GetDMSelfServicePscTypes`);
  myDeptEmployees = this.transferHttp.getHot(`hr/GetOnlyMyDeptEmps`);

  //Field Values
  routedFrom = "selfServicePsc";

  //Grid Data
  ssPscs = this.transferHttp.getHot(`hr/GetMySelfServicePscsInProcess`);
  dmPscs = this.transferHttp.getHot(`hr/GetDmSelfServicePscsInProcess`);

  //***************************
  // Functions
  //***************************

  selfServicePsc() {
    this.routedFrom = "selfServicePsc";
    this.router.navigate([`hr/selfServicePsc/${this.routedFrom}`]);
  }

  employeeId: number = this.transferHttp.getCache(CacheItem.user).employeeId;
  dmSelfServicePsc(empId: number) {
    this.routedFrom = "dmSelfServicePsc";
    this.router.navigate([`hr/dmSelfServicePsc/${this.routedFrom}/${empId}`]);
  }

  //***************************
  // Init
  //***************************

  ngOnInit(): void {
  }
}
